/* eslint-disable max-len */
import { IApplicationData } from 'src/interfaces/ApplicationData';
import { API_EMBED_BASE_URL } from 'src/utils/envUtils';

export const pallyconLicenseEndpointLegacy = (data: IApplicationData) =>
  `${API_EMBED_BASE_URL}/v1/drm/${data.mediaCode}/license?signature=${data.signature}&user=${data.userCode}&token=${data.applicationKey}`;

export const pallyconLicenseEndpoint = (data: IApplicationData) => {
  if (!data.isJwtSignature) return pallyconLicenseEndpointLegacy(data);
  return `${API_EMBED_BASE_URL}/v2/drm/${data.mediaCode}/license?token=${data.signature}&userCode=${data.userCode}&applicationCode=${data.applicationKey}`;
};
